module.exports = __webpack_public_path__ + "img/product-meat.bc5894e3.png";